<template>
  <div
    class="px-2 py-[0.125rem] gap-1 flex flex-initial items-center text-xs rounded-full"
    :style="{
      backgroundColor: level.bgColor,
      color: level.textColor
    }"
  >
    <BaseIcon icon="book-alt" />
    <span class="font-medium">{{ level.name }}</span>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'HubTopicsListItemLevelChip',

  components: { BaseIcon },

  props: {
    topic: { type: Object, required: true }
  },

  computed: {
    level() {
      const levels = {
        basic: {
          name: 'Basic',
          textColor: '#11683D',
          bgColor: '#DCFCE7'
        },
        intermediate: {
          name: 'Intermediate',
          textColor: '#213BAC',
          bgColor: '#DAE9FF'
        },
        advanced: {
          name: 'Advanced',
          textColor: '#7B2AA2',
          bgColor: '#F3E6FE'
        }
      }

      return levels[this.topic.level]
    }
  }
}
</script>
